/* eslint-env browser */
import { isFunction } from 'lodash';
import page from 'page';
import pageExit from './page-exit';

const config = window.APP_CONFIG;

function abPage(...args) {
  const pageArgs = args.map(arg => {
    if (!isFunction(arg)) {
      return arg;
    }

    return (ctx, next) => {
      if (ctx.winningFullPageVariantName === 'original') {
        return arg.call(arg, ctx, next);
      }

      return next();
    };
  });

  page.apply(page, pageArgs);
}

abPage.exit = pageExit;

abPage.redirect = page.redirect;

export default (config.disable_analytics ? page : abPage);



// WEBPACK FOOTER //
// ./src/modules/ab-page-js/page.js